<template>
  <div id="app">
    <AppWait v-if="workspaceLoading">
      App start is in progress. Please wait...
    </AppWait>
    <router-view />
  </div>
</template>

<script>
import AppWait from '@/components/shared/AppWait'
import { mapActions, mapState } from 'vuex'
import { DOMAIN_ANY, DOMAIN_WORKSPACE } from '@/router/helpers'

export default {
  name: 'app',
  components: {
    AppWait
  },
  data: () => ({
    loadCommonDataInterval: null
  }),
  methods: {
    ...mapActions(['loadCommonData']),
    ...mapActions('auth', ['userMessagesHandlerBind', 'localStorageUpdateBind'])
  },
  computed: {
    ...mapState(['workspaceStatus', 'modalActiveCount']),
    workspaceLoading() {
      let requireDomain = this.$route.meta.requireDomain || DOMAIN_ANY
      return requireDomain === DOMAIN_WORKSPACE && Object.keys(this.workspaceStatus).length === 0
    }
  },
  created() {
    this.loadCommonDataInterval = setInterval(() => {
      this.loadCommonData().then((isStart) => isStart && clearInterval(this.loadCommonDataInterval), () => {})
    }, 200)

    // bind callback on localStorage change (for tabs sync)
    this.userMessagesHandlerBind()
    this.localStorageUpdateBind()
  },
  destroyed() {
    clearInterval(this.loadCommonDataInterval)
  }
}
</script>

<style src="@/assets/appwork/bootstrap.scss" lang="scss"></style>
<style src="@/assets/appwork/appwork.scss" lang="scss"></style>
<style src="@/assets/appwork/theme-twitlight.scss" lang="scss"></style>
<style src="@/assets/appwork/colors.scss" lang="scss"></style>
<style src="@/assets/appwork/uikit.scss" lang="scss"></style>
<style src="@/assets/main.scss" lang="scss"></style>

<style lang="scss">
.modal-active {
  overflow: hidden;
}
</style>
